/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/


export const OlafMissingSegmentsDtoTypeEnum = {
    MISSING_SEGMENTS: "MISSING_SEGMENTS"
} as const;

export type OlafMissingSegmentsDtoTypeEnumKey = (typeof OlafMissingSegmentsDtoTypeEnum)[keyof typeof OlafMissingSegmentsDtoTypeEnum];

export type OlafMissingSegmentsDto = {
    /**
     * @type string
    */
    type: OlafMissingSegmentsDtoTypeEnumKey;
    /**
     * @type string
    */
    datetime: string;
};